import { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogContent, useMediaQuery } from '@mui/material';

import { IUserFromStorage } from '../../Interfaces/IUser';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const ModalSupport = ({ isOpen, setIsOpen }: Props) => {

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const isMobile = useMediaQuery('(max-width: 650px)');
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} >

      <DialogContent>
        <div className="text-center flex flex-col items-center">
          <p className='p-2 mt-3 text-base'> Hola {user.nombres}, Para tener un mejor control de tu caso, por favor escríbenos todas tus consultas desde el mismo correo con el que te tenemos registrado: </p>
          <span className='font-bold text-base'> {user.correo} </span>
          <a href={isMobile ? 'mailto:clientes@club.tr4iner.com' : 'https://mail.google.com/mail/?view=cm&fs=1&to=clientes@club.tr4iner.com'} target='_blank' rel="noopener noreferrer">
            <button className="mt-4 py-[10px] px-[20px] bg-orangeTr4iner text-white rounded-md text-center">
              Escríbenos
            </button>
          </a>
        </div>
      </DialogContent>

    </Dialog>
  )
}

export default ModalSupport;
